"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.removeUrlSegment = removeUrlSegment;
function removeUrlSegment(segment) {
  if (!segment) {
    return;
  }
  const newPath = window.location.pathname.replace(`${segment}`, '').replace('//', '/');
  window.history.replaceState({}, '', `${newPath}${window.location.search}`);
}